import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import VueCookie from 'vue-cookie'
import mixins from '../_mixins'
import { Trans } from '@/plugins/Translation'
import { authService } from '@/services'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:locale',
    component: {
      template: "<router-view></router-view>"
    },
    beforeEnter: Trans.routeMiddleware,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('../views/Home'),
        meta: { requiresAuth: true },
      },

      // --------------AUTH---------------
      {
        path: 'login',
        name: 'login',
        component: () => import('../views/auth/Login'),
        meta: { authBlocked: true },
      },
      {
        path: 'register',
        name: 'register',
        component: () => import('../views/auth/Register'),
      },
      {
        path: 'register/:token?',
        name: 'registerToken',
        component: () => import('../views/auth/Register'),
      },
      {
        path: 'reset-password/:token?',
        name: 'newPassword',
        component: () => import('../views/auth/NewPassword'),
      },

      // ---------------Admin------------------
      {
        path: 'events',
        name: 'EventList',
        component: () => import('../views/tables/events/EventList'),
        meta: { requiresAuth: true },
      },
      {
        path: 'admin/events',
        name: 'EventListAdmin',
        component: () => import('../views/tables/events/EventListAdmin'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: 'admin/users',
        name: 'UserListAdmin',
        component: () => import('../views/tables/users/UserListAdmin'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: 'admin/users/:id',
        name: 'adminUserEdit',
        component: () => import('../views/admin/user/EditUser'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      // Пока так сделано , что бы работало, в будущем будет переделано как в WebinarMount !
      {
        path: 'event/add',
        name: 'EventAdd',
        component: () => import('../views/tables/events/EventAdd'),
        meta: { requiresAuth: true },
      },
      {
        path: 'event/edit/:id',
        name: 'EventEdit',
        component: () => import('../views/tables/events/EventEdit'),
        meta: { requiresAuth: true },
      },
      {
        path: 'admin/event/add',
        name: 'adminEventAdd',
        component: () => import('../views/tables/events/EventAdd'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: 'admin/event/edit/:id',
        name: 'adminEventEdit',
        component: () => import('../views/tables/events/EventEdit'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: 'exhibitors/:id',
        name: 'exhibitorList',
        component: () => import('../views/tables/exhibitors/ExhibitorList'),
        meta: { requiresAuth: true },
      },
      {
        path: 'admin/exhibitors/:id',
        name: 'exhibitorListAdmin',
        component: () => import('../views/tables/exhibitors/ExhibitorListAdmin'),
        meta: { requiresAuth: true },
      },
      {
        path: 'admin/exhibitors/:eventId/edit/:id',
        name: 'exhibitorEdit',
        component: () => import('../views/admin/exhibitors/ExhibitorEdit'),
        meta: { requiresAuth: true },
      },
      // {
      //   path: 'admin/new-user/',
      //   name: 'newUser',
      //   component: () => import('../views/admin/user/NewUser'),
      //   meta: { requiresAuth: true, requiresAdmin: true },
      // },
      // {
      //   path: 'admin/edit-user/:id?',
      //   name: 'editUser',
      //   component: () => import('../views/admin/user/EditUser'),
      //   meta: { requiresAuth: true, requiresAdmin: true },
      // },
      {
        path: 'exhibitor/:id',
        name: 'exhibitor',
        component: () => import('../views/exhibitor/ExhibitorRequest'),
        meta: { requiresAuth: true },
      },
      {
        path: 'visitor/:id',
        name: 'visitor',
        component: () => import('../views/visitor/JoinEvent'),
        meta: { requiresAuth: true },
      },
      {
        path: 'exhibitor/configure/:id',
        name: 'exhibitorConfigure',
        component: () => import('../views/exhibitor/ConfigureBooth'),
        meta: { requiresAuth: true },
      },
      {
        path: 'webinar/:eventId',
        name: 'webinarAdd',
        component: () => import('../views/webinars/WebinarMount'),
        meta: { requiresAuth: true },
      },
      {
        path: 'webinars/:eventId/:webinarId',
        name: 'webinarEdit',
        component: () => import('../views/webinars/WebinarMount'),
        meta: { requiresAuth: true },
      },
      {
        path: 'admin/webinars/:id',
        name: 'webinarListAdmin',
        component: () => import('../views/tables/webinars/WebinarListAdmin'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },

      {
        path: 'webinars/:id',
        name: 'webinarList',
        component: () => import('../views/tables/webinars/WebinarsList'),
        meta: { requiresAuth: true },
      },


      {
        path: 'profile',
        name: 'profile',
        component: () => import('../views/user/Profile'),
        meta: { requiresAuth: true },
      },
      {
        path: 'exit',
        name: 'exit',
        component: () => import('../views/Exit'),
        meta: { requiresAuth: false },
      },
      {
        path: 'test',
        name: 'test',
        component: () => import('../views/test'),
        meta: { requiresAuth: false },
      },


      // ---------------Errors-------------------
      {
        path: 'no-access',
        name: 'noAccess',
        component: () => import('../views/NoAccess'),
      },
      {
        path: '*',
        name: 'notFound',
        component: () => import('../views/NotFound'),
      },
    ]
  },
  {
    path: '*',
    redirect() {
      return Trans.defaultLocale;
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const needsAuth = to.matched.some((record) => record.meta.requiresAuth)
  const needsAdmin = to.matched.some((record) => record.meta.requiresAdmin)
  const authBlocked = to.matched.some((record) => record.meta.authBlocked)
  let isAuthenticated = store.state.authentication.isAuthenticated
  const isCookieAuthed = VueCookie.get('authenticated') === 'true'

  if (isCookieAuthed && !isAuthenticated) {
    // need to set auth state if getting here from auth cookie
    const data = JSON.parse(localStorage.getItem('user'))

    store.commit('user/set', data.user)
    store.commit('authentication/set', {
      authenticated: true,
      token: data.token,
    })
    isAuthenticated = true
  }

  if (authBlocked) {
    // if (isAuthenticated) {
    //   next('/reports')
    //   return
    // }
  }

  if (needsAuth) {
    if (isAuthenticated) {
      if (needsAdmin) {

        let isAdmin = false;
        const token = store.state.authentication.token

        if(to.name !== 'Exit') {
          mixins.getUserRole(token).then((result) => {
            isAdmin = result.name === 'admin' || result.name === 'superadmin';

            //console.log('needs admin')
            //console.log('store.getters[\'user/isAdmin\']', store.getters['user/isAdmin'])
            if (isAdmin) {
              next()
              return
            } else {
              next('/en/no-access')
              return
            }
          })
        }
      }
      // if (store.getters['user/isSubscriptionExpired']) {
      //   await authService.logout()
      //   next({
      //     path: '/login',
      //     query: {
      //       info: 'Your subscription has expired. Please contact support',
      //     },
      //   })
      //   return
      // }
      next()
      return
    }
    // this.router.push({ name: 'register' })
    next('/en/login')
    // window.location.href = "/en/login";
    // next({ name: 'register' })
    return
  } else {
    next()
  }
});

router.afterEach((to, from) => {

});

export default router
